export const ADMIN_ORGANIZATION_STORAGE_KEY = 'akiva.admin.activeOrganizationId';

export function getStoredAdminOrganizationId(): string | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(ADMIN_ORGANIZATION_STORAGE_KEY);
}

export function storeAdminOrganizationId(orgId: string | null): void {
  if (typeof window === 'undefined') return;
  if (orgId) window.localStorage.setItem(ADMIN_ORGANIZATION_STORAGE_KEY, orgId);
  else window.localStorage.removeItem(ADMIN_ORGANIZATION_STORAGE_KEY);
}
